import { Lens } from "src/app/shared/utilities/state/Optics";
import { GoogleTagManagerState } from "./googleTagManager.models";

const stateLensProp = Lens.fromProp<GoogleTagManagerState>();
export const productAddedEventLens = stateLensProp("productAddedEvent");
export const productRemovedEventLens = stateLensProp("productRemovedEvent");
export const cartViewedEventLens = stateLensProp("cartViewedEvent");
export const checkoutStartedEventLens = stateLensProp("checkoutStartedEvent");
export const orderCompletedEventLens = stateLensProp("orderCompletedEvent");
export const couponAppliedEventLens = stateLensProp("couponAppliedEvent");
